module.exports = __webpack_public_path__ + "static/assets/966afb28c86ad452a9fdcafe05d1bf2b.svg";